import {
  LOAD_BUSINESS_RULES,
  BUSINESS_RULES_LOADED,
  SYNC_FAILED,
  RESET_BUSINESS_RULES,
  RESET_BUSINESS_RULE,
  BUSINESS_RULE_DELETED,
  LOAD_BUSINESS_RULES_TYPES,
  BUSINESS_RULES_TYPES_LOADED,
  LOAD_BUSINESS_RULES_ACTION,
  BUSINESS_RULES_ACTION_LOADED,
  LOAD_BUSINESS_RULE,
  BUSINESS_RULE_LOADED,
  SAVE_BUSINESS_RULE,
  BUSINESS_RULES_SAVED,
  SET_RULE_ID,
  RESET_RULE_ID,
} from './actionTypes';
import { IBusinessRule, IBusinessRulesState } from './types';

export const initialState: IBusinessRulesState = {
  error: null,
  businessRulesLoaded: false,
  businessRuleLoaded: false,
  businessTypesLoaded: false,
  businessActionLoaded: false,
  businessRules: [],
  businessTypes: [],
  businessAction: [],
  businessRule: null,
  businessRuleSaved: false,
  ruleId: undefined,
  syncing: false,
};

export const reducer = (
  state = initialState,
  action: { type: string; payload?: any }
): IBusinessRulesState => {
  switch (action.type) {
    case LOAD_BUSINESS_RULES:
      return { ...state, error: null, syncing: true };
    case BUSINESS_RULES_LOADED:
      return {
        ...state,
        error: null,
        businessRules: action.payload,
        syncing: false,
        businessRulesLoaded: true,
      };
    case LOAD_BUSINESS_RULE:
      return { ...state, error: null, syncing: true };
    case BUSINESS_RULE_LOADED:
      return {
        ...state,
        error: null,
        businessRule: action.payload,
        syncing: false,
        businessRuleLoaded: true,
      };
    case LOAD_BUSINESS_RULES_TYPES:
      return { ...state, error: null, syncing: true };
    case BUSINESS_RULES_TYPES_LOADED:
      return {
        ...state,
        error: null,
        businessTypes: action.payload,
        syncing: false,
        businessTypesLoaded: true,
      };
    case RESET_BUSINESS_RULES:
      return initialState;
    case RESET_BUSINESS_RULE:
      return { ...state, businessRule: null };
    case BUSINESS_RULE_DELETED:
      const newBusinessRules = state.businessRules.filter((item: IBusinessRule) => {
        return item.ruleId !== action.payload;
      });
      return { ...state, businessRules: newBusinessRules };
    case LOAD_BUSINESS_RULES_ACTION:
      return { ...state, error: null, syncing: true };
    case BUSINESS_RULES_ACTION_LOADED:
      return {
        ...state,
        error: null,
        businessAction: action.payload,
        syncing: false,
        businessActionLoaded: true,
      };
    case SAVE_BUSINESS_RULE:
      return {
        ...state,
        error: null,
        businessRuleSaved: false,
        syncing: true,
      };
    case BUSINESS_RULES_SAVED:
      return {
        ...state,
        businessRuleSaved: !state.businessRuleSaved,
        syncing: false,
      };
    case SET_RULE_ID:
      return {
        ...state,
        ruleId: action.payload,
      };
    case RESET_RULE_ID:
      return {
        ...state,
        ruleId: undefined,
      };
    case SYNC_FAILED:
      return { ...state, syncing: false, error: action.payload };
    default:
      return state;
  }
};
